import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache,ApolloLink } from '@apollo/client/core';

import {global} from './conection';
const uri = global.urlgraph;

export function createApollo(httpLink: HttpLink) {
  const user = localStorage.getItem('x-key');
  const token = localStorage.getItem('token');

  const authMiddleware = new ApolloLink((operation, forward) => {
    const token = localStorage.getItem('token');
    const usuario = localStorage.getItem('x-key');
    operation.setContext({
      headers: {
        autorization: token ? token : '',
        user: usuario ? usuario : ''
      }
    });
    return forward(operation);
  });

  const afterwareLink = new ApolloLink((operation, forward) =>
  forward(operation).map(response => {
    const context = operation.getContext();
    const { response: { headers } } = context;
    if (headers) {
      const token = headers.get('autorization');
      if (token) {
        var cadena=window.location.pathname;
        if(token=='0'&& cadena!='/sigrrhh/principal/login' && cadena!='/sigrrhh/principal/register'){
          window.alert("La sesión ha expirado, vuelva a ingresar sus datos de acceso.");
            window.location.href = "/sigrrhh/principal/login";
        }
        localStorage.setItem('token', token);
      }
    }
    return response;
  }),
);

  const link = ApolloLink.from([authMiddleware,afterwareLink, httpLink.create({ uri })]);
  const cache = new InMemoryCache({addTypename:false});

  return {
    link,
    cache,
    defaultOptions: {
      watchQuery: {
          fetchPolicy:'no-cache',
          errorPolicy: 'ignore'
      },
      mutate: {
          errorPolicy: 'all'
      }
     }
  }
}

@NgModule({
  exports: [
    HttpClientModule,
  ],
  providers: [{
    provide: APOLLO_OPTIONS,
    useFactory: createApollo,
    deps: [HttpLink]
  }]
})
export class GraphQLModule {}
